import { useState } from "react"
import { useAtom } from "@reatom/npm-react"
import classnames from "classnames"

import { useAnalytics } from "utils/analytics"
import { Columns, Column } from "ui-kit/components-branded/index"
import { formAtom } from "modules/PsyCatalog/common/models/filterForm"
import { AgeSelector } from "modules/PsyCatalog/common/Filters/AgeSelector"
import { SexSelector } from "modules/PsyCatalog/common/Filters/SexSelector"
import { MaritalStatusSelector } from "modules/PsyCatalog/common/Filters/MaritalStatusSelector"
import { HasChildrenSelector } from "modules/PsyCatalog/common/Filters/HasChildrenSelector"
import { WorkingWithFilters } from "modules/PsyCatalog/common/Filters/WorkingWithFilters"

export const AdvancedFilters = () => {
    const [shown, setShown] = useState(false)
    const [formState] = useAtom(formAtom)
    const Analytics = useAnalytics()

    return (
        <div className="advanced-search">
            <div className="strike advanced-search-block">
                <button
                    type="button"
                    className="strike-content strike-content-right advanced-search-button"
                    onClick={() => {
                        setShown(true)
                        Analytics?.search_form_advanced_shown(formState)
                    }}
                >
                    <i className="fas fa-list"> </i> Расширенный поиск
                </button>
            </div>
            <div
                className={classnames("advanced-search-block", {
                    "advanced-search-collapsed": !shown,
                })}
            >
                <p className="advanced-search-explanation">
                    Внимание:{" "}
                    <strong>
                        Умение вас услышать и&nbsp;понять зависит от&nbsp;квалификации специалиста,
                        а&nbsp;не&nbsp;от&nbsp;его личного опыта.
                    </strong>
                    <br />
                    <br />
                    Характеристики, приведенные ниже, не&nbsp;влияют на&nbsp;квалификацию.
                    Мы&nbsp;рекомендуем в&nbsp;первую очередь ориентироваться на&nbsp;специализацию,
                    образование и&nbsp;описание &laquo;о&nbsp;себе&raquo;. Тем не&nbsp;менее,
                    мы&nbsp;понимаем, что для многих людей может быть легче раскрываться
                    в&nbsp;разговоре с&nbsp;собеседником определенного возраста или, например, пола.
                    Поэтому мы&nbsp;даем возможность искать по&nbsp;таким критериям.
                </p>
                <Columns>
                    <Column>
                        <AgeSelector />
                    </Column>
                    <Column>
                        <SexSelector />
                    </Column>
                </Columns>
                <Columns>
                    <Column>
                        <MaritalStatusSelector />
                    </Column>
                    <Column>
                        <HasChildrenSelector />
                    </Column>
                </Columns>
                <WorkingWithFilters />
            </div>
        </div>
    )
}
